import { PaymentMethodConfig } from "@models/payments/PaymentMethodConfig";
import { ErrorService } from "@providers/ErrorService";
import { Observable } from "rxjs";
import { UserService } from "../UserService";
import { PaymentMethodBehaviour, PaymentMethodBehaviourResult, SkipAmountResult } from "./PaymentMethodBase";

export class PuntoPagoMethodBehaviour extends PaymentMethodBehaviour {
  behaviour = PaymentMethodConfig.PUNTO_PAGO.behaviour;
  name = this.behaviour.name; //"Punto Pago"
  image = this.behaviour.image; //"puntoPagoLogo";
  track = this.behaviour.track; //"AccessToPuntoPago";
  isBank = this.behaviour.isBank; //false;
  minDepositAmount: number;
  maxDepositAmount: number;
  amountButtons: number[];
  declare amount: number;

  constructor(userService: UserService, errorService: ErrorService) {
    super(false, userService, errorService);
  }
  skipAmountInput(): Observable<SkipAmountResult> {
    throw new Error("Method not implemented.");
  }

  paymentMetodExecution(): Observable<PaymentMethodBehaviourResult> {
    throw new Error("Method not implemented.");
  }
}
